import { Timezones } from "@obby/constants";
import { UTCDate__Add } from "./UTCDate__Add";
import { UTCDate__FormattedDate } from "./UTCDate__FormattedDate";

export function Session__DisplayTime(
  session: any,
  timezone: string = Timezones.EUROPE_LONDON,
  forceTimezone: boolean = false,
) {
  const { startDateTime, duration, isOnline } = session;

  if (isOnline && !forceTimezone)
    timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ?? timezone;

  const endDateTime = UTCDate__Add(
    startDateTime,
    duration,
    "minutes",
    timezone,
  );

  const startTime = UTCDate__FormattedDate(startDateTime, timezone, "h:mma");
  const endTime = UTCDate__FormattedDate(endDateTime, timezone, "h:mma");

  return startTime + " - " + endTime;
}
